<template>
    <section>
        <div class="row">
            <div class="col-12">
                <accounting-book @bookNumber="setBookNumber($event)"></accounting-book>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <accounting-list :bookNumber="bookNumber"></accounting-list>
            </div>
        </div>
    </section>
</template>

<script>
import AccountingBook from '@/components/accounting/Book';
import AccountingList from '@/components/accounting/List';

export default {
    components: {
        AccountingBook,
        AccountingList
    },
    data() {
        return {
            bookNumber: -1
        }
    },
    methods: {
        setBookNumber(value) {
            this.bookNumber = value;
        }
    }
}
</script>